const featuresWiredBasic = [
    {
        "name": "b_nd",
        "displayName": "LED Module Nominal Data",
    }
];

const featuresWiredAdvanced = [
    {
        "name": "a_nd",
        "displayName": "Nominal Data",
    }
]

const featuresWiredPremium = [
    {
        "name": "p_nd",
        "displayName": "Nominal Data",
    },
    {
        "name": "p_ma",
        "displayName": "Module Architecture",
    },
    {
        "name": "p_tc",
        "displayName": "Thermal Characteristics",
    },
    {
        "name": "p_cd",
        "displayName": "Current Dependencies",
    },
    {
        "name": "p_td",
        "displayName": "Temperature Dependencies",
    }
];

const ORIGINAL_LEDMODULE_ID = 1;

var featuresWired = (type) => {
    switch(type) {
        case "B":
            return featuresWiredBasic;
        case "A":
            return featuresWiredAdvanced;
        case "P":
            return featuresWiredPremium;
        default:
            return [];
    }
}

const features = {
    
    "basicNominalData": {
        "shortName": "b_nd",

        "physicalColdest": "PhysicalCoolest",
        "physicalWarmest": "PhysicalWarmest",
        "physicalColdestK": "PhysicalCoolestK",
        "physicalWarmestK": "PhysicalWarmestK",
    },

    "advancedNominalData": {
        "shortName": "a_nd",

        "moduleTemperatureAmbient": "Ta",
        "moduleTemperatureCh0": "Tmod_Ch0",
        "moduleTemperatureCh1": "Tmod_Ch1",
        "operatingCurrentCh0": "Nominalcurrent-Led0",
        "operatingCurrentCh1": "Nominalcurrent-Led1",
        "ratedVoltageCh0": "RatedVoltageLEDCH1",
        "ratedVoltageCh1": "RatedVoltageLEDCH2",
        "luminousFluxCh0": "Flux-Led0",
        "luminousFluxCh1": "Flux-Led1",
        "colourCoordinateXCh0": "X-Led0",
        "colourCoordinateXCh1": "X-Led1",
        "colourCoordinateYCh0": "Y-Led0",
        "colourCoordinateYCh1": "Y-Led1",
        "physicalColdest": "PhysicalCoolest",
        "physicalWarmest": "PhysicalWarmest",
        "physicalColdestK": "PhysicalCoolestK",
        "physicalWarmestK": "PhysicalWarmestK",
    },

    "nominalData": {
        "shortName": "p_nd",

        "moduleTemperatureAmbient": "Ta",
        "moduleTemperatureCh0": "Tmod_Ch0",
        "moduleTemperatureCh1": "Tmod_Ch1",
        "operatingCurrentCh0": "Nominalcurrent-Led0",
        "operatingCurrentCh1": "Nominalcurrent-Led1",
        "ratedVoltageCh0": "RatedVoltageLEDCH1",
        "ratedVoltageCh1": "RatedVoltageLEDCH2",
        "luminousFluxCh0": "Flux-Led0",
        "luminousFluxCh1": "Flux-Led1",
        "colourCoordinateXCh0": "X-Led0",
        "colourCoordinateXCh1": "X-Led1",
        "colourCoordinateYCh0": "Y-Led0",
        "colourCoordinateYCh1": "Y-Led1",
        "physicalColdest": "PhysicalCoolest",
        "physicalWarmest": "PhysicalWarmest",
        "physicalColdestK": "PhysicalCoolestK",
        "physicalWarmestK": "PhysicalWarmestK",
    },
    "moduleArchitecture": {
        "shortName": "p_ma",

        "numberOfLedStringsCh0": "ParallelLEDstringsperLED-Channel-CH1",
        "numberOfLedStringsCh1": "ParallelLEDstringsperLED-Channel-CH2",
        "numberOfLedsPerStringsCh0": "LEDInOneStringperLED-Channel-CH1",
        "numberOfLedsPerStringsCh1": "LEDInOneStringperLED-Channel-CH2",
    },
    "thermalCharacteristics": {
        "shortName": "p_tc",

        "thermalResistanceJunction": "ThermalResistanceJunction"
    },
    "currentDependencies": {
        "shortName": "p_cd",

        "ratedCurrentOfLedMinCh0": "RatedCurrentOfLedMin-CH1",
        "ratedCurrentOfLedMinCh1": "RatedCurrentOfLedMin-CH2",
        "ratedCurrentOfLedMedCh0": "RatedCurrentOfLedMed-CH1",
        "ratedCurrentOfLedMedCh1": "RatedCurrentOfLedMed-CH2",
        "ratedCurrentOfLedMaxCh0": "RatedCurrentOfLedMax-CH1",
        "ratedCurrentOfLedMaxCh1": "RatedCurrentOfLedMax-CH2",

        "luminousFluxCurrentMinCh0": "LuminousFlux-Current-Min-CH1",
        "luminousFluxCurrentMinCh1": "LuminousFlux-Current-Min-CH2",
        "luminousFluxCurrentMedCh0": "LuminousFlux-Current-Med-CH1",
        "luminousFluxCurrentMedCh1": "LuminousFlux-Current-Med-CH2",
        "luminousFluxCurrentMaxCh0": "LuminousFlux-Current-Max-CH1",
        "luminousFluxCurrentMaxCh1": "LuminousFlux-Current-Max-CH2",

        "colourCoordinateCurrentXMinCh0": "ColourCoordinate-Current-X-Min-CH1",
        "colourCoordinateCurrentXMinCh1": "ColourCoordinate-Current-X-Min-CH2",
        "colourCoordinateCurrentXMedCh0": "ColourCoordinate-Current-X-Med-CH1",
        "colourCoordinateCurrentXMedCh1": "ColourCoordinate-Current-X-Med-CH2",
        "colourCoordinateCurrentXMaxCh0": "ColourCoordinate-Current-X-Max-CH1",
        "colourCoordinateCurrentXMaxCh1": "ColourCoordinate-Current-X-Max-CH2",

        "colourCoordinateCurrentYMinCh0": "ColourCoordinate-Current-Y-Min-CH1",
        "colourCoordinateCurrentYMinCh1": "ColourCoordinate-Current-Y-Min-CH2",
        "colourCoordinateCurrentYMedCh0": "ColourCoordinate-Current-Y-Med-CH1",
        "colourCoordinateCurrentYMedCh1": "ColourCoordinate-Current-Y-Med-CH2",
        "colourCoordinateCurrentYMaxCh0": "ColourCoordinate-Current-Y-Max-CH1",
        "colourCoordinateCurrentYMaxCh1": "ColourCoordinate-Current-Y-Max-CH2"
    },
    "temperatureDependencies": {
        "shortName": "p_td",

        "temperatureMinCh0": "Temperature-Min-CH1",
        "temperatureMinCh1": "Temperature-Min-CH2",
        "temperatureMedCh0": "Temperature-Med-CH1",
        "temperatureMedCh1": "Temperature-Med-CH2",
        "temperatureMaxCh0": "Temperature-Max-CH1",
        "temperatureMaxCh1": "Temperature-Max-CH2",

        "luminousFluxTemperatureMinCh0": "LuminousFlux-Temperature-Min-CH1",
        "luminousFluxTemperatureMinCh1": "LuminousFlux-Temperature-Min-CH2",
        "luminousFluxTemperatureMedCh0": "LuminousFlux-Temperature-Med-CH1",
        "luminousFluxTemperatureMedCh1": "LuminousFlux-Temperature-Med-CH2",
        "luminousFluxTemperatureMaxCh0": "LuminousFlux-Temperature-Max-CH1",
        "luminousFluxTemperatureMaxCh1": "LuminousFlux-Temperature-Max-CH2",

        "colourCoordinateTemperatureXMinCh0": "ColourCoordinate-Temperature-X-Min-CH1",
        "colourCoordinateTemperatureXMinCh1": "ColourCoordinate-Temperature-X-Min-CH2",
        "colourCoordinateTemperatureXMedCh0": "ColourCoordinate-Temperature-X-Med-CH1",
        "colourCoordinateTemperatureXMedCh1": "ColourCoordinate-Temperature-X-Med-CH2",
        "colourCoordinateTemperatureXMaxCh0": "ColourCoordinate-Temperature-X-Max-CH1",
        "colourCoordinateTemperatureXMaxCh1": "ColourCoordinate-Temperature-X-Max-CH2",

        "colourCoordinateTemperatureYMinCh0": "ColourCoordinate-Temperature-Y-Min-CH1",
        "colourCoordinateTemperatureYMinCh1": "ColourCoordinate-Temperature-Y-Min-CH2",
        "colourCoordinateTemperatureYMedCh0": "ColourCoordinate-Temperature-Y-Med-CH1",
        "colourCoordinateTemperatureYMedCh1": "ColourCoordinate-Temperature-Y-Med-CH2",
        "colourCoordinateTemperatureYMaxCh0": "ColourCoordinate-Temperature-Y-Max-CH1",
        "colourCoordinateTemperatureYMaxCh1": "ColourCoordinate-Temperature-Y-Max-CH2"
    },
}

const BASIC_NOMINAL_DATA = features.basicNominalData;
const ADVANCED_NOMINAL_DATA = features.advancedNominalData;
const NOMINAL_DATA = features.nominalData;
const MODULE_ARCHITECTURE = features.moduleArchitecture;
const THERMAL_CHARACTERISTICS = features.thermalCharacteristics;
const CURRENT_DEPENDENCIES = features.currentDependencies;
const TEMPERATURE_DEPENDENCIES = features.temperatureDependencies;

export {

    featuresWired,

    ORIGINAL_LEDMODULE_ID,

    BASIC_NOMINAL_DATA,
    ADVANCED_NOMINAL_DATA,
    NOMINAL_DATA,
    MODULE_ARCHITECTURE,
    THERMAL_CHARACTERISTICS,
    CURRENT_DEPENDENCIES,
    TEMPERATURE_DEPENDENCIES,
    
}